import { SyntheticEvent } from 'react'

import { Link } from '~/components'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import ChevronDownIcon from '~/components/Icons/svgs/ChevronDownIcon'
import ChevronRightIcon from '~/components/Icons/svgs/ChevronRightIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { AppLanguage } from '~/types/locale'
import SVGImage from '~/components/Image/SVGImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]
interface Props {
  iconSrcKey: string
  iconAltText: string
  productTitle: string
  productSubtitle: string
  cardTitle: string
  productHref?: string
  hrefLocale?: AppLanguage | undefined
  onClickTitle: (evt: SyntheticEvent) => void
  showContent: boolean
  titleClassname?: string
  shouldShowCurriculum?: boolean
  curriculumCountryCode?: string
}

export default function SummaryHeader(props: Props): React.ReactElement {
  const {
    iconSrcKey,
    iconAltText,
    productTitle,
    productSubtitle,
    cardTitle,
    productHref,
    hrefLocale,
    onClickTitle,
    showContent,
    titleClassname = '',
    shouldShowCurriculum = false,
    curriculumCountryCode,
  } = props

  const curriculumCountryFlagImageSrc = `country-flags-rect/${curriculumCountryCode?.toUpperCase()}.svg`

  return (
    <div className="flex justify-between">
      <div className="flex gap-2">
        <ResponsiveImage
          alt={iconAltText}
          height={108}
          imageClassName="w-9"
          mediaQuery={mediaQuery}
          srcKey={iconSrcKey}
          width={108}
        />
        <div className="text-left">
          <p>
            {productTitle} {productSubtitle ? ' - ' : ''} <span className="font-light">{productSubtitle}</span>
          </p>
          <div className="flex gap-2 items-center">
            {productHref ? (
              <Link locale={hrefLocale} onClick={onClickTitle} to={productHref}>
                <p className={`font-medium ${titleClassname}`}>{cardTitle}</p>
              </Link>
            ) : (
              <p className={`font-medium ${titleClassname}`}>{cardTitle}</p>
            )}
            {shouldShowCurriculum && (
              <SVGImage
                alt={curriculumCountryCode}
                className="w-5"
                imageClassName="h-5 rounded-0.5"
                srcKey={curriculumCountryFlagImageSrc}
              />
            )}
          </div>
        </div>
      </div>
      <SVGIcon icon={showContent ? ChevronDownIcon : ChevronRightIcon} pathClassName="text-black" size={14} />
    </div>
  )
}
